import styled from 'styled-components'
import { borderRounded } from '../../styles/radius'
import breakpoints from '../../styles/breakpoints'

export const Overlay = styled.div`
  background-color: black;
  width: 100%;
  height: 1200px;
  position: fixed;
  top: 0;
  opacity: 0.6;
`

type CountriesProps = {
  open: boolean;
}

export const Countries = styled.div<CountriesProps>`
  background-color: white;
  border: 1px solid #DEDFE4;
  border-radius: 12px 12px 0 0;
  position: fixed;
  width: 100%;
  transition: all ease-in-out 500ms;
  bottom: ${(props: CountriesProps) => props.open ? '0' : '-100%'};

  @media (min-width: ${breakpoints.lg}) {
    width: 360px;
    position: absolute;
    border-radius: 0 0 12px 12px;
    right: 0;
    top: 54px;
    display: ${(props: CountriesProps) => props.open ? 'inline-table' : 'none'};
  }

  .trace-menu {
    width: 48px;
    height: 4px;
    background-color: #DEDFE4;
    margin: 0 auto;
    border-radius: 8px;
  }
`

export const Flags = styled.div`
  cursor: pointer;
  border: 1px solid #DEDFE4;
  padding: 1rem;
  margin: auto 1rem 1.5rem;
  border-radius: ${borderRounded['8']};
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  bottom: 30px;
  position: absolute;
  width: 90%;
  padding: 12px;
  right: 0;

  @media (min-width: ${breakpoints.lg}) {
    bottom: 0;
    border: none;
    float: right;
    margin: 0;
    width: auto;
    position: absolute;
    top: 0;
    z-index: 9999;
  }
  
  .icon-chevron {
    @media (min-width: ${breakpoints.lg}) {
      transition: all ease-in-out 200ms;
      transform: ${(props: CountriesProps) => props.open ? 'rotate(180deg)' : 'rotate(0deg)'};
    }
  }
`

export const FlagsOpened = styled.div`
  display: flex;
  align-items: center;
  width: 100%; 
`

export const FlagsCurrent = styled(FlagsOpened)`
  border-bottom: 1px solid #DEDFE4;
`

export const LinkFlags = styled.span`
  width: 100%;
  border-bottom: 1px solid #DEDFE4;  
  float: left;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }  
`